import { UAParser } from 'my-ua-parser';

import * as popover from './popover';
import * as tooltip from './tooltip';

const parser = new UAParser();
const device = parser.getResult().device;
const isDesktop = !device.type;

// NOTE: Tooltip component does not work properly in mobile environment because mouseover event cannot be obtained.
//       Therefore, in mobile environments, use the Popover component instead to respond to tap operations.
const Tooltip = isDesktop ? tooltip.Tooltip : popover.Popover;
const TooltipTrigger = isDesktop
  ? tooltip.TooltipTrigger
  : popover.PopoverTrigger;
const TooltipContent = isDesktop
  ? tooltip.TooltipContent
  : popover.PopoverContent;
const TooltipProvider = tooltip.TooltipProvider;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
